import { render, staticRenderFns } from "./viewingDisciplineTests.vue?vue&type=template&id=3c66dfbd"
import script from "./viewingDisciplineTests.vue?vue&type=script&lang=js"
export * from "./viewingDisciplineTests.vue?vue&type=script&lang=js"
import style0 from "./viewingDisciplineTests.vue?vue&type=style&index=0&id=3c66dfbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports